import jsPDF from "jspdf";
import { PTSCONVERSION, imageUrlToDataUrl } from "../../../../utils";

// Logo
import logo from "/public/images/studio-logo-green.png";
import { id } from "date-fns/locale";

interface FooterProps {
  output: boolean;
  margin?: number;
  textFillColor: string;
  startX?: number;
  imageHeight?: number;
  marketDetails: {
    logo?: string | null;
    name?: string;
    email?: string;
    phone?: string;
  };
}

export default async function footer(doc: jsPDF, config: FooterProps) {
  const pageCount = doc.getNumberOfPages();
  const output = config.output;
  const margin = config.margin || 10;
  let currentX = margin;

  // Add Studio Logo
  currentX = martEyeLogo(doc, {
    ...config,
    startX: currentX,
    output: false,
  });

  // Add Market Logo
  currentX = marketLogo(doc, config.marketDetails.logo || "", {
    ...config,
    startX: currentX,
    imageHeight: 8,
    output: false,
  });

  // Want to calculate the height of the legal text
  const legalHeight = marketText(doc, {
    ...config,
    output: false,
    startX: currentX,
  });

  footerLineBreak(
    doc,
    {
      ...config,
      output: false,
    },
    legalHeight
  );

  if (!output) {
    return;
  }

  for (var i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    currentX = margin;

    pageNumbers(doc, config, legalHeight);

    // Add Studio Logo
    currentX = martEyeLogo(doc, {
      ...config,
      startX: currentX,
    });

    // Add Market Logo
    currentX = marketLogo(doc, config.marketDetails.logo || "", {
      ...config,
      imageHeight: 8,
      startX: currentX,
    });

    marketText(doc, {
      ...config,
      startX: currentX,
    });

    footerLineBreak(doc, config, legalHeight);
  }
}

function martEyeLogo(doc: jsPDF, config: FooterProps) {
  const margin = config.margin || 10;
  const startX = config.startX || margin;
  const output = config.output;
  const imageHeight = config.imageHeight || 6;
  const pageHeight = doc.internal.pageSize.getHeight();

  // Add the image to the document
  if (output) {
    // Get the base 64 image

    doc.addImage(
      "data:image/png;base64,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",
      "PNG",
      startX,
      pageHeight - imageHeight - margin / 4 - 1.5,
      20,
      imageHeight,
      undefined,
      "FAST"
    );
  }

  // Add 25% margin to the width
  return 20 + margin * 1.5;
}
function marketLogo(doc: jsPDF, src: string, config: FooterProps) {
  const margin = config.margin || 10;
  let startX = config.startX || margin;
  const output = config.output || true;
  const imageHeight = config.imageHeight || 8;
  const pageHeight = doc.internal.pageSize.getHeight();

  if (!src) {
    return startX;
  }

  if (output) {
    let linePosition = doc.linePosition || pageHeight - margin / 2;

    // Also add a vertical line to separate the logo from the content
    doc.setLineWidth(0.1);
    doc.setDrawColor("#8B8B8B");
    doc.line(startX, linePosition + 2, startX, pageHeight - 2);

    startX += margin / 2;

    doc.addImage(
      src,
      "PNG",
      startX,
      pageHeight - imageHeight - margin / 4,
      imageHeight,
      imageHeight,
      undefined,
      "FAST"
    );
  }

  // Add 25% margin to the width
  return startX + imageHeight + margin / 4;
}

function marketText(doc: jsPDF, config: FooterProps) {
  // Config
  const margin = config.margin || 10;
  let startX = config.startX || margin;
  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageNumberWidth = doc.getTextWidth("Page 100 of 1000");
  const output = config.output || true;

  let marketDetailsHeight = 0;

  // Set the total tags read and total tags to the page
  const marketName = config.marketDetails?.name || null;
  let spaceAvailable = pageWidth - pageNumberWidth - startX - margin * 2;

  if (marketName) {
    doc.setFontSize(8);
    doc.setFont("Inter", "bold");
    doc.setTextColor(config.textFillColor);
    marketDetailsHeight = doc.getLineHeight() * PTSCONVERSION;

    let expectedWidth = doc.getTextWidth(marketName);
    if (expectedWidth < spaceAvailable) {
      // Subtract the width from the space available
      spaceAvailable = spaceAvailable - expectedWidth;

      if (output) {
        doc.text(
          marketName,
          startX,
          pageHeight - margin / 2 - marketDetailsHeight,
          {
            align: "left",
            baseline: "top",
          }
        );
      }

      startX += expectedWidth + margin / 4;
    }
  }

  const marketEmail = config.marketDetails?.email || null;
  const marketPhone = config.marketDetails?.phone || null;

  let marketContact = "";
  if (marketEmail && marketPhone) {
    marketContact = `|  ${marketEmail}  |  ${marketPhone}`;
  } else if (marketEmail) {
    marketContact = `|  ${marketEmail}`;
  } else if (marketPhone) {
    marketContact = `|  ${marketPhone}`;
  }

  if (marketContact) {
    doc.setFont("Inter", "normal");
    marketDetailsHeight = doc.getLineHeight() * PTSCONVERSION;

    let expectedWidth = doc.getTextWidth(marketContact);
    if (expectedWidth < spaceAvailable) {
      // Subtract the width from the space available
      spaceAvailable = spaceAvailable - expectedWidth;

      if (output) {
        doc.text(
          marketContact,
          startX,
          pageHeight - margin / 2 - marketDetailsHeight,
          {
            align: "left",
            baseline: "top",
          }
        );
      }
      startX += expectedWidth;
    }
  }

  return marketDetailsHeight;
}

function pageNumbers(doc: jsPDF, config: FooterProps, legalTextHeight: number) {
  const margin = config.margin || 10;
  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageCount = doc.getNumberOfPages();
  const currentPage = doc.getCurrentPageInfo().pageNumber;
  // Set Page Number to the current page
  doc.setFont("Inter", "normal");
  doc.setFontSize(8);
  doc.text(
    "Page " + String(currentPage) + " of " + String(pageCount),
    pageWidth - margin,
    pageHeight - margin / 2 - legalTextHeight,
    {
      align: "right",
      baseline: "top",
      maxWidth: pageWidth - margin * 2,
    }
  );
}

function footerLineBreak(
  doc: jsPDF,
  config: FooterProps,
  legalTextHeight: number
) {
  const margin = config.margin || 10;
  // If we are not outputting the document, then we don't need to add the line
  const linePosition =
    doc.internal.pageSize.getHeight() - margin / 2 - 5 - legalTextHeight;
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const output = config.output || true;

  // Now safe zone for the bottom of each page is the line position - 5
  const safeZone = linePosition - 5;
  doc.mainFooterPosition = pageHeight - safeZone;

  doc.linePosition = linePosition;

  if (!output) {
    return safeZone;
  }

  // Now add a line to separate the footer from the content
  doc.setLineWidth(0.25);
  doc.setDrawColor(config.textFillColor);
  doc.line(margin, linePosition, pageWidth - margin, linePosition);
}
